import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import {
  failureDashboardCard,
  successDashboardCard,
} from "./DashboardCardSlice";

const DashboardCardApi = () => {
  return api.get('/dashboard/card');
};
export function* DashboardCardCall() {
  try {
    const response: AxiosResponse = yield call(DashboardCardApi);
    yield put(successDashboardCard(response.data));
  } catch (error) {
    yield put(failureDashboardCard(error));
  }
}
